var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveSidebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 40,
    viewBox: "0 0 10 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -10,
    width: 20,
    height: 40,
    rx: 10,
    fill: "#45185A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveSidebar);
export default __webpack_public_path__ + "static/media/activeSidebar.0cb747744edc250ded4f58bab1584f21.svg";
export { ForwardRef as ReactComponent };